import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle } from "@material-ui/lab";


import { Link, Typography } from "@material-ui/core";

import { HIDDENFAULTS_TOKEN, HIDDENFAULTS_REFRESH } from "../../application/constants";
import { setTimeOutLogoutMessage, setAppInit, setIsAuthenticated } from "../../application/actions";
import { useAppState } from "../../application/AppState";

const useStyles = makeStyles({
    root: {
        display: "block",
        marginBottom: "1rem",
    },
    alert: {
        marginTop: ".5rem",
    },
    link: {
        marginLeft: ".2rem",
        marginRight: ".2rem",
    },
});

const tryVerifyPartner = async (partnerIdentity) => {
    const response = await fetch("verify", {
        method: "POST",
        body: JSON.stringify({
            partnerIdentity: partnerIdentity,
        }),
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
        },
    });
    if (response.ok) return response;
    if (response.status == 401) {
        return Promise.reject("Unauthorized");
    }
    const json = await response.json();
    return Promise.reject(json);
};

export const LoginTest = () => {
    const [{ language }, dispatch] = useAppState();
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [timeOut, setTimeOut] = useState(false);
    const { formState, register, handleSubmit } = useForm({
        mode: "onChange",
    });

    const styles = useStyles();
    const { isValid } = formState;

    useEffect(() => {
        setTimeOut(JSON.parse(window.localStorage.getItem('timeOut')));
        localStorage.removeItem("timeOut");
    }, []);

    const onSubmit = async ({ partnerIdentity }) => {

        //alert(JSON.stringify(partnerIdentity));

        try {
            const response = await tryVerifyPartner(partnerIdentity);
            const auth = await response.json();
            sessionStorage.setItem(HIDDENFAULTS_TOKEN, auth.token);
            sessionStorage.setItem(HIDDENFAULTS_REFRESH, auth.refreshToken);
            dispatch(setAppInit(true));
            dispatch(setTimeOutLogoutMessage(false));
            dispatch(setIsAuthenticated(true))

        } catch (e) {
            console.log(e);
            setError(true);
        } finally {
            setLoading(false);
        }
    };
   
    // 212000-0142
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                <TextField
                    className={styles.root}
                    label="Token"
                    variant="outlined"
                    fullWidth={true}
                    {...register("partnerIdentity", {
                        required: "Obligatoriskt",
                        //validate: (v) => verifyCompanyOrgNumber(v) || verifyPersonNumber(v) || "Ogiltigt organisations eller personnummer",
                    })}

                />

                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    type="submit"
                    fullWidth={true}
                    disabled={!isValid || loading}

                >
                    Logga in
                </Button>
            </form>
            {timeOut &&
                <Alert severity="error" className={styles.alert}>
                    <AlertTitle>Info</AlertTitle>
                    <Typography variant="body2" component="p">
                        Du har blivit utloggad pga att det tagit för lång tid...............
                    </Typography>
                </Alert>
            }
            {error && (
                <Alert severity="error" className={styles.alert}>
                    <AlertTitle>Info</AlertTitle>
                    <Typography variant="caption" component="p">
                        Hej! Tack för din kontakt med oss.
                    </Typography>
                    <Typography variant="caption" component="p">
                        Vi kan tyvärr inte hitta dig i vårt register. Klicka på knappen nedan för att komma vidare. <br />
                    </Typography>
                    <Typography variant="caption" component="p">
                        Vi ser fram emot att få hjälpa dig och dina säljare framöver med Uppdaga dolda felförsäkringar!
                    </Typography>
                    <Typography variant="caption" component="p">
                        Om du behöver komma i kontakt med oss når du oss på: <br />
                        <Link className={styles.link} href="mailto:saljservice@wtwco.com">
                            saljservice@wtwco.com
                        </Link>
                        eller
                        <Link className={styles.link} href="tel:+46-8-5463 5990">
                            +46-8-5463 5990
                        </Link>
                    </Typography>
                </Alert>
            )}
        </>
    );
};
export default LoginTest;